import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, signal } from '@angular/core';

@Component({
  selector: 'app-cookies-disabled-banner',
  imports: [],
  templateUrl: './cookies-disabled-banner.component.html',
  styleUrl: './cookies-disabled-banner.component.scss'
})
export class CookiesDisabledBannerComponent {
  private readonly PLATFORM_ID = inject(PLATFORM_ID);

  protected cookiesEnabled = signal(true);

  public constructor() {
    if (isPlatformBrowser(this.PLATFORM_ID)) {
      this.cookiesEnabled.set(navigator.cookieEnabled);
    }
  }
}
